import React, { useState } from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, BarChart, Bar, XAxis, YAxis } from 'recharts';

const NPS_RESPONSES = [
  { score:9, contact:'Emma Thompson',  company:'Man City',       comment:'Excellent platform, scouts are very professional', date:'Apr 3, 2026' },
  { score:10,contact:'James Morris',   company:'Arsenal FC',     comment:'Best scouting tool we\'ve used, very fast turnaround', date:'Apr 2, 2026' },
  { score:7, contact:'Tom Nakamura',   company:'Sydney FC',      comment:'Good service, would like more scouts in Oceania', date:'Apr 1, 2026' },
  { score:8, contact:'Alex Aldridge',  company:'Colorado Rapids',comment:'Very smooth process, payments are fast', date:'Mar 31, 2026' },
  { score:6, contact:'Pierre Dubois',  company:'PSG',            comment:'Decent platform but UI could be more intuitive', date:'Mar 30, 2026' },
  { score:9, contact:'Sarah Kim',      company:'LA Galaxy',      comment:'Love the premium evaluation detail level', date:'Mar 29, 2026' },
  { score:3, contact:'Luca Bianchi',   company:'Juventus',       comment:'Had issues during onboarding, support was slow', date:'Mar 28, 2026' },
  { score:8, contact:'Henrik Larsson', company:'Malmo FF',       comment:'Great scout network in Scandinavia', date:'Mar 27, 2026' },
];

const CSAT_DATA = [
  { label:'Very satisfied', value:42, color:'#A7F432' },
  { label:'Satisfied',      value:31, color:'#4fc3f7' },
  { label:'Neutral',        value:15, color:'#f5a623' },
  { label:'Dissatisfied',   value:8,  color:'#ff4d4d' },
  { label:'Very dissatisfied',value:4,color:'#8a9a97' },
];

const NPS_DIST = Array.from({length:11},(_,i)=>({ score:i, count:NPS_RESPONSES.filter(r=>r.score===i).length }));

const npsColor = s => s >= 9 ? '#A7F432' : s >= 7 ? '#f5a623' : '#ff4d4d';
const npsLabel = s => s >= 9 ? 'Promoter' : s >= 7 ? 'Passive' : 'Detractor';

export default function Surveys({ toast }) {
  const [tab, setTab] = useState('nps');

  const promoters  = NPS_RESPONSES.filter(r=>r.score>=9).length;
  const detractors = NPS_RESPONSES.filter(r=>r.score<=6).length;
  const npsScore   = Math.round(((promoters-detractors)/NPS_RESPONSES.length)*100);
  const csatScore  = Math.round((CSAT_DATA.slice(0,2).reduce((s,d)=>s+d.value,0)/CSAT_DATA.reduce((s,d)=>s+d.value,0))*100);

  return (
    <div>
      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">NPS score</div><div className="stat-value" style={{ color:npsScore>=50?'#A7F432':npsScore>=0?'#f5a623':'#ff4d4d' }}>{npsScore}</div><div className="stat-sub">{promoters} promoters · {detractors} detractors</div></div>
        <div className="stat-card"><div className="stat-label">CSAT score</div><div className="stat-value" style={{ color:'var(--accent)' }}>{csatScore}%</div><div className="stat-sub stat-up">Satisfaction rate</div></div>
        <div className="stat-card"><div className="stat-label">Responses</div><div className="stat-value">{NPS_RESPONSES.length}</div><div className="stat-sub">Total received</div></div>
        <div className="stat-card"><div className="stat-label">Response rate</div><div className="stat-value">34%</div><div className="stat-sub">Of surveys sent</div></div>
      </div>

      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
        <div className="filter-pills" style={{ marginBottom:0 }}>
          {['nps','csat'].map(t=><button key={t} className={`pill ${tab===t?'active':''}`} onClick={()=>setTab(t)} style={{ textTransform:'uppercase', fontSize:11 }}>{t}</button>)}
        </div>
        <button className="btn btn-primary" onClick={()=>toast?.('Survey sent to all active contacts')}>Send survey</button>
      </div>

      {tab==='nps' && (
        <div>
          <div className="two-col" style={{ marginBottom:20 }}>
            <div className="card">
              <div className="card-header"><span className="card-title">NPS distribution</span></div>
              <ResponsiveContainer width="100%" height={180}>
                <BarChart data={NPS_DIST} margin={{ top:4,right:4,left:-20,bottom:0 }}>
                  <XAxis dataKey="score" tick={{ fill:'#646B6B',fontSize:11 }} axisLine={false} tickLine={false}/>
                  <YAxis tick={{ fill:'#646B6B',fontSize:11 }} axisLine={false} tickLine={false}/>
                  <Tooltip contentStyle={{ background:'#131B1B',border:'1px solid #2a3a3a',borderRadius:8,fontSize:12 }}/>
                  <Bar dataKey="count" name="Responses" radius={[4,4,0,0]}>
                    {NPS_DIST.map((d,i)=><Cell key={i} fill={npsColor(d.score)}/>)}
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
              <div style={{ display:'flex', justifyContent:'center', gap:20, marginTop:12 }}>
                {[['Promoters',promoters,'#A7F432'],['Passives',NPS_RESPONSES.length-promoters-detractors,'#f5a623'],['Detractors',detractors,'#ff4d4d']].map(([label,count,color])=>(
                  <div key={label} style={{ textAlign:'center' }}>
                    <div style={{ fontSize:20, fontWeight:700, color }}>{count}</div>
                    <div style={{ fontSize:11, color:'var(--text-dim)' }}>{label}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className="card">
              <div className="card-header"><span className="card-title">Overall NPS</span></div>
              <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:'20px 0' }}>
                <div style={{ fontSize:72, fontWeight:700, color:npsScore>=50?'#A7F432':npsScore>=0?'#f5a623':'#ff4d4d', lineHeight:1 }}>{npsScore}</div>
                <div style={{ fontSize:13, color:'var(--text-muted)', marginTop:8 }}>Net Promoter Score</div>
                <div style={{ fontSize:11, color:'var(--text-dim)', marginTop:4 }}>Industry avg: 32</div>
                <div style={{ width:'100%', maxWidth:200, height:6, background:'var(--border)', borderRadius:3, marginTop:20, overflow:'hidden' }}>
                  <div style={{ width:`${((npsScore+100)/200)*100}%`, height:'100%', background:'#A7F432', borderRadius:3 }}/>
                </div>
                <div style={{ display:'flex', justifyContent:'space-between', width:'100%', maxWidth:200, marginTop:4 }}>
                  <span style={{ fontSize:10, color:'var(--text-dim)' }}>-100</span>
                  <span style={{ fontSize:10, color:'var(--text-dim)' }}>+100</span>
                </div>
              </div>
            </div>
          </div>

          <div className="card" style={{ padding:0 }}>
            <div className="card-header" style={{ padding:'16px 20px', borderBottom:'1px solid var(--border)' }}>
              <span className="card-title">Individual responses</span>
            </div>
            <div className="table-wrap">
              <table>
                <thead><tr><th>Contact</th><th>Company</th><th>Score</th><th>Type</th><th>Comment</th><th>Date</th></tr></thead>
                <tbody>
                  {NPS_RESPONSES.map((r,i)=>(
                    <tr key={i}>
                      <td style={{ fontWeight:500 }}>{r.contact}</td>
                      <td style={{ color:'var(--text-muted)',fontSize:12 }}>{r.company}</td>
                      <td><span style={{ fontWeight:700,fontSize:16,color:npsColor(r.score) }}>{r.score}</span></td>
                      <td><span style={{ padding:'3px 8px',borderRadius:99,fontSize:11,background:`${npsColor(r.score)}22`,color:npsColor(r.score) }}>{npsLabel(r.score)}</span></td>
                      <td style={{ fontSize:12,color:'var(--text-muted)',maxWidth:280 }}>{r.comment}</td>
                      <td style={{ fontSize:11,color:'var(--text-dim)' }}>{r.date}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {tab==='csat' && (
        <div className="two-col">
          <div className="card">
            <div className="card-header"><span className="card-title">CSAT breakdown</span></div>
            <ResponsiveContainer width="100%" height={220}>
              <PieChart>
                <Pie data={CSAT_DATA} cx="50%" cy="50%" outerRadius={85} dataKey="value" label={({name,percent})=>`${(percent*100).toFixed(0)}%`} labelLine={false}>
                  {CSAT_DATA.map((d,i)=><Cell key={i} fill={d.color}/>)}
                </Pie>
                <Tooltip contentStyle={{ background:'#131B1B',border:'1px solid #2a3a3a',borderRadius:8,fontSize:12 }}/>
              </PieChart>
            </ResponsiveContainer>
            <div style={{ display:'flex', flexDirection:'column', gap:8, marginTop:8 }}>
              {CSAT_DATA.map(d=>(
                <div key={d.label} style={{ display:'flex', alignItems:'center', gap:10 }}>
                  <div style={{ width:10,height:10,borderRadius:'50%',background:d.color,flexShrink:0 }}/>
                  <span style={{ fontSize:12,color:'var(--text-muted)',flex:1 }}>{d.label}</span>
                  <span style={{ fontSize:12,fontWeight:600,color:d.color }}>{d.value}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="card">
            <div className="card-header"><span className="card-title">CSAT score</span></div>
            <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:'30px 0' }}>
              <div style={{ fontSize:72, fontWeight:700, color:'var(--accent)', lineHeight:1 }}>{csatScore}%</div>
              <div style={{ fontSize:13, color:'var(--text-muted)', marginTop:8 }}>Customer Satisfaction</div>
              <div style={{ fontSize:11, color:'var(--text-dim)', marginTop:4 }}>Based on {CSAT_DATA.reduce((s,d)=>s+d.value,0)} responses</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
